export const constant = {
	selector: {
		pptxLinkExport: '.js-pptx-export',
	},
}
